module.exports = __webpack_public_path__ + "img/202406-xs.ef6899d3.png";